import { PazienRouter } from "common/routers/pazienRouter";
import { products } from "common/routers/products";

export const LoginRouter = PazienRouter.extend({
    appRoutes: {
        login: {
            method: "login",
            product: products.authentication,
            ensureAuth: false
        },
        "login/provider/:id": {
            method: "loginWithProvider",
            product: products.authentication,
            ensureAuth: false
        },
        logout: {
            method: "logout",
            product: products.authentication,
            ensureAuth: true
        },
        reset: {
            method: "reset",
            product: products.authentication,
            ensureAuth: false
        },
        new_user: {
            method: "new_user",
            product: products.authentication,
            ensureAuth: false
        },
        saml: {
            method: "saml_user",
            product: products.authentication,
            ensureAuth: false
        },
        saml_error: {
            method: "saml_error",
            product: products.authentication,
            ensureAuth: false
        }
    }
});
